import type { Commodity } from '@enmon/commons/lib/shared';
import { Button, Card, Flex, Space, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { getInventorizationCommodityOptions } from '@/features/inventorization/identity-options';
import { messages } from '@/features/inventorization/messages';

interface InventorizeCommodityStepProps {
  commodity: Commodity | '';
  onBack: () => void;
  onNext: (commodity: Commodity | '') => Promise<void>;
}

export function InventorizeCommodityStep({ commodity, onBack, onNext }: InventorizeCommodityStepProps) {
  const intl = useIntl();
  const commodityOptions = getInventorizationCommodityOptions();

  return (
    <Space orientation="vertical" size="large" style={{ width: '100%' }}>
      <div>
        <Typography.Title level={2} style={{ margin: 0 }}>
          {intl.formatMessage(messages.identityCommodityTitle)}
        </Typography.Title>
        <Typography.Paragraph type="secondary">
          {intl.formatMessage(messages.identityCommodityDescription)}
        </Typography.Paragraph>
      </div>

      <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
        {commodityOptions.map(option => {
          const isSelected = commodity === option.value;

          return (
            <Card
              hoverable
              key={option.value}
              onClick={() => {
                void onNext(option.value);
              }}
              style={{ borderColor: isSelected ? '#1677ff' : undefined }}
              styles={{ body: { padding: 16 } }}
            >
              <Space align="center" size="middle">
                <Flex
                  align="center"
                  justify="center"
                  style={{
                    border: '1px solid #d9d9d9',
                    borderRadius: 8,
                    fontSize: 20,
                    fontWeight: 700,
                    height: 56,
                    width: 56,
                  }}
                >
                  {option.shortLabel}
                </Flex>
                <Typography.Text strong>{option.label}</Typography.Text>
              </Space>
            </Card>
          );
        })}
      </div>

      <Flex gap="small" justify="space-between" wrap>
        <Button onClick={onBack} size="large">
          {intl.formatMessage(messages.appCommonBack)}
        </Button>
        <Button disabled={!commodity} onClick={() => void onNext(commodity)} size="large" type="primary">
          {intl.formatMessage(messages.appCommonNext)}
        </Button>
      </Flex>
    </Space>
  );
}
